import { defineComponent as _defineComponent } from 'vue'
import { i18n } from '@/i18n';
import { useReturningUserStore } from '@/store/returning-user-module';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import ReturnCoupon from '@tencent/wphk-components-returning-user/components/return-coupon.vue';
import { SimpleCouponAwardCodeMap } from '@tencent/wphk-components-returning-user/types';
import { FitButton } from '@tencent/wphk-ui';
import { PropType, ref } from 'vue';
import { showReturnActExecDialog } from '../business/error-dialog';
import { useBiReport } from '../hooks/use-report';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { CHANLE_ID, SUBSCRIBE_CONFIG } from '@tencent/wphk-components-returning-user/config-subscribe';
import { initSubscribe, handleIsShowWxSubscribe, handleOnSuccess, handleOnFail } from '@tencent/wphk-components-wx-subscribe/business';


export default /*#__PURE__*/_defineComponent({
  __name: 'reward-list',
  props: {
  awardInfo: { type: Object as PropType<SimpleCouponAwardCodeMap>, required: true },
},
  setup(__props) {

const props = __props



const returningUserStore = useReturningUserStore();
const { biExt } = useBiReport();

/** 是否展示订阅开放标签 */
const isShowWxSubscribe = ref(false);
/** 订阅模板Id数组 */
const templateIds = SUBSCRIBE_CONFIG[0]?.templateId ? [SUBSCRIBE_CONFIG[0].templateId] : [];  // 订阅模板Id写在回流组件内

async function init() {
  // 初始化订阅
  initSubscribe(CHANLE_ID, SUBSCRIBE_CONFIG);
  isShowWxSubscribe.value = await handleIsShowWxSubscribe();
}
init();

/** */
const getCoupon = async () => {
  showLoading();
  const [err] = await to(returningUserStore.execAct(props.awardInfo));
  hideLoading();
  if (err) {
    showReturnActExecDialog(err as Error);
    return;
  }
};

/**
 * 订阅成功/订阅取消回调
 */
function onSuccess(res) {
  // 1、无论成功/取消，都要发起领券请求
  getCoupon();
  // 2、将订阅信息同步后台
  handleOnSuccess(res);
}

/**
 * 按钮操作失败回调(跟订阅成功/订阅失败没有关系)
 */
function onFail(res) {
  // 1、即使是操作失败，也要领券
  getCoupon();
  // 2、数据上报
  handleOnFail(res);
}

return { __sfc: true,props, returningUserStore, biExt, isShowWxSubscribe, templateIds, init, getCoupon, onSuccess, onFail, i18n, ReturnCoupon, FitButton, WxSubscribe }
}

})